import { ProgressBarFull } from "@in/component-library";
import React, { FC } from "react";

interface CircleProgressbarProps {
  percentage: number;
  ariaLabel?: string;
  id?: string;
  ariaHidden?: boolean;
}

const CircleProgressbar: FC<CircleProgressbarProps> = ({ percentage, ariaLabel = "Progressbar", id, ariaHidden }) => {
  const radius = 35;
  const circleCircumference = 2 * Math.PI * radius;

  return (
    <div className="circle-progressbar" id={id} aria-hidden={ariaHidden}>
      <div
        role="progressbar"
        aria-valuenow={percentage}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={ariaLabel}
        className="circle-progressbar__circle"
      >
        <svg width="100" height="100">
          <circle className="circle-progressbar__bar" cx="50" cy="50" r={radius} fill="none" strokeWidth="5" />
          <circle
            className="circle-progressbar__indicator"
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            strokeWidth="5"
            strokeDasharray={circleCircumference}
            strokeDashoffset={circleCircumference - (circleCircumference * percentage) / 100}
          />
        </svg>
      </div>
      <div className="circle-progressbar__full">
        <ProgressBarFull percentage={percentage} />
      </div>
    </div>
  );
};

export default CircleProgressbar;
